import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  DateField,
  EditButton,
  TextInput,
  
  ReferenceInput,
  SelectInput,
  DateTimeInput,
  translate,
  FunctionField,
  Show,
  SimpleShowLayout,

  ListButton,
  Filter
} from "react-admin";
import { CardActions } from "@material-ui/core";
import {
    required,
    password,
    passwordEdit,
    passwordEquals
} from "../../validators/validators";

const ClientCustomerFilter = props => (
  <Filter {...props}>
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.id"
      source="id"
    />
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.email"
      source="email"
      allowEmpty
    />
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.country"
      source="country"
    />
  </Filter>
);

export const ClientCustomerList = props => (
  <List {...props} exporter={false} filters={<ClientCustomerFilter />}  bulkActionButtons={false}>
    <Datagrid>
      <TextField label="resources.misc.fields.firstName" source="firstName" />
      <TextField label="resources.misc.fields.lastName" source="lastName" />
      <TextField label="resources.misc.fields.companyName" source="companyName" />
      <TextField label="resources.misc.fields.email" source="email" />
      <TextField label="resources.misc.fields.phonenumber" source="phonenumber" />
      <TextField label="resources.misc.fields.address" source="address" />
      <TextField label="resources.misc.fields.zip" source="zip" />
      <TextField label="resources.misc.fields.city" source="city" />
      <TextField label="resources.misc.fields.country" source="country" />
      <EditButton label="" /> 
    </Datagrid>
  </List>
);

const ClientCustomerTitle = ({ record }) => {
    return (
      <span>{record ? record.companyName || `${record.firstName} ${record.lastName}` : ""}</span>
    );
};

const cardActionStyle = {
    zIndex: 2,
    display: "inline-block",
    float: "right"
};

const Actions = ({ basePath, data, refresh }) => (
  <CardActions style={cardActionStyle}>
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export const ClientCustomerShow = props => (
  <Show 
  title={<ClientCustomerTitle />} 
  actions={<Actions />}
  {...props}>
    <SimpleShowLayout>
      <DateField label="resources.misc.fields.createdAt" source="createdAt" />
      <DateField label="resources.misc.fields.updatedAt" source="updatedAt" />
      <TextField label="resources.misc.fields.firstName" source="firstName" />
      <TextField label="resources.misc.fields.lastName" source="lastName" />
      <TextField label="resources.misc.fields.email" source="email"   allowEmpty/>
      <TextField label="resources.misc.fields.phonenumber" source="phonenumber"  allowEmpty />
      <TextField label="resources.misc.fields.address" source="address" />
      <TextField label="resources.misc.fields.zip" source="zip" />
      <TextField label="resources.misc.fields.city" source="city" />
      <TextField label="resources.misc.fields.country" source="country" />
      <TextField label="resources.misc.fields.companyName" source="companyName" />
    
    </SimpleShowLayout>
  </Show>
);

export const ClientCustomerEdit = ({ permissions, ...props }) => (
  <Edit title={<ClientCustomerTitle />} actions={<CardActions />} {...props}>
    <SimpleForm>
     
      <TextInput
        label="resources.misc.fields.firstName"
        source="firstName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.lastName"
        source="lastName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.email"
        source="email"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.phonenumber"
        source="phonenumber"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.address"
        source="address"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.zip"
        source="zip"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.city"
        source="city"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.country"
        source="country"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.companyName"
        source="companyName"
        // validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.vat"
        source="vat"
        // validate={[required()]}
      />
    </SimpleForm>
  </Edit>
);

export const ClientCustomerCreate = ({ permissions, ...props }) => (
  <Create title="Nova stranka" {...props}>
    <SimpleForm redirect="list">

      <TextInput
        label="resources.misc.fields.firstName"
        source="firstName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.lastName"
        source="lastName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.email"
        source="email"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.phonenumber"
        source="phonenumber"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.address"
        source="address"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.zip"
        source="zip"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.city"
        source="city"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.country"
        source="country"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.companyName"
        source="companyName"
        // validate={[required()]}
      />
      
      <TextInput
        label="resources.misc.fields.vat"
        source="vat"
        // validate={[required()]}
      />

    </SimpleForm>
  </Create>
);